export enum HAS_FREESPINS_ENUM {
  YES = "Yes",
  NO = "No",
  PARTIALLY = "Partially",
}

export enum STATUS_ENUM {
  ACTIVE = "Active",
  INACTIVE = "Inactive",
}

export type ProviderResponseType = {
  statusCode: number;
  data: ProviderType[];
};

export type ProviderType = {
  name: string;
  hasDemo: boolean;
  positionMob: number;
  positionWeb: number;
  currency: number | null;
  geo: string | null;
  hasFreespins:
    | HAS_FREESPINS_ENUM.YES
    | HAS_FREESPINS_ENUM.NO
    | HAS_FREESPINS_ENUM.PARTIALLY;
  status: STATUS_ENUM.ACTIVE | STATUS_ENUM.INACTIVE;
};

export type GameType = {
  uuid: string;
  name: string;
  customName: string; // Кастомное имя (приоритетнее name)
  customImage: string; // Кастомное изображение (приоритетнее name)
  image: string;
  type: string; // Категория со слотегратора
  technology: string;
  has_lobby: number;
  is_mobile: number;
  has_freespins: number;
  freespin_valid_until_full_day: number;
  availableMob: boolean;
  availableWeb: boolean;
  positionMob: number;
  positionWeb: number;
  recommendationsMob: number;
  recommendationsWeb: number;
  status: string;
  urlAlias: string;
  provider: ProviderType;
};

export type GamesResponseType = {
  data: GameType[];
  total: number;
  page: number;
  lastPage: number;
  statusCode: number;
};

export type ParamsRequestType = {
  tournament?: string;
  take?: number;
  page?: number;
  providers?: string;
  platform?: string;
  categories?: string;
  name?: string;
  sort?: string;
  top?: boolean;
};

export type CategoryResponseType = {
  statusCode: number;
  data: CategoryDataResponseType[];
};

export type CategoryDataResponseType = {
  name: string;
};

export type InitGameRequestType = {
  returnUrl?: string;
  id: string;
  lang: string;
  mode: GAME_MODE;
  platform: "web" | "mobile";
};

export type InitByAliasGameRequestType = {
  alias: string;
  mode: GAME_MODE;
  lang: string;
  returnUrl?: string;
  platform?: "web" | "mobile";
};

export type InitGameResponseType = {
  url: string;
  statusCode: number;
};

export type InitGameByAliasResponseType = {
  url: string;
  statusCode: number;
  game: GameType;
};

export type FavoriteRequestType = {
  urlAlias: string;
};

export type FavoritesResponseType = {
  favoriteGames: GameType[];
};

export type HistoryResponseType = {
  statusCode: number;
  data: HistoryResponseDataType[];
};

export type NewHistoryResponseType = {
  id: number;
  name: string;
  uuid: string;
  urlAlias: string;
  provider: NewProviderType;
};

export type NewProviderType = {
  aggregatorId: number;
  hasDemo: boolean;
  id: number;
  image: string;
  isActive: boolean;
  name: string;
  providerGroupId: number;
};

export type HistoryResponseDataType = {
  id: number;
  game: GameType;
  playerId: number;
  playerName: string;
  currency: string;
  lobbyData: string;
  createdAt: string;
  updatedAt: string;
};

export type TournamentGameRequestType = {
  id: string;
  take?: number;
  page?: number;
  providers?: string;
  platform?: string;
  categories?: string;
};

export enum GAME_MODE {
  DEMO = "demo",
  REAL = "real",
}

export enum GAME_PLATFORM {
  MOB = "mobile",
  WEB = "web",
}

export enum GAME_SORT_ENUMS {
  ABC = "abc",
  ZYX = "zyx",
  POP = "pop",
  NEW = "new",
}

export type GameSortType = {
  id: string;
  title: string;
  option: string;
};

export type GameParams = {
  mode: GAME_MODE;
  gameName: string;
  tournament?: string;
};
